/* global angular  */
import './style.less';
import tourText from './tourText';

export default function($log, $state, $stateParams, $q, $transitions, ApiClass, ProfileClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  const { company_id } = ProfileClass.profileComplete.profile;
  // Onboarding Top
  $transitions.onExit({ exiting: 'app.author.evaluationForms.evaluationForm.edit' }, () => {
    if (vm.tour) vm.tour.end();
  });
  vm.tourReady = tour => (vm.tour = tour);
  vm.startTour = init => {
    if (!init || (init && $stateParams.tour === 'start')) vm.tour.start();
  };

  vm.tourText = tourText;
  vm.formData = undefined;
  vm.resultsQueried = false;
  vm.answerData = {
    checkbox: [],
    input: [],
    radio: [],
    text_area: [],
    instructors: {
      checkbox: [],
      input: [],
      radio: [],
      text_area: []
    }
  };

  const instructors = {
    checkbox: [],
    input: [],
    radio: [],
    text_area: []
  };

  vm.submit = formData => {
    if (formData.active === true) return $state.go('app.author.evaluationForms', $stateParams);

    formData.id = $stateParams.form_id;
    formData.active = false;
    return ApiClass.companiesIdTypeTypeIdPatch(
      { manage: true, id: company_id, type: 'evaluationForms', type_id: $stateParams.form_id },
      formData
    )
      .then(() => {
        if (formData.submitType === 'next') return $state.go('app.author.evaluationForms.evaluationForm', $stateParams);
        $state.reload();
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  function activate() {
    $log.debug('Evaluation Form Edit Loaded');
    vm.loaded = false;
    vm.error = {};

    return ApiClass.companiesIdTypeTypeIdGet(
      { manage: true, id: company_id, type: 'evaluationForms', type_id: $stateParams.form_id },
      null
    )
      .then(({ data: { item } }) => {
        $log.debug('Evaluation Form Edit Data', item);
        if (item.active === true) return $state.go('app.author.evaluationForms');
        if (!item.instructors) item.instructors = angular.copy(instructors);
        vm.formData = item;
        vm.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        vm.loaded = true;
        vm.error = {
          status: true,
          refresh: activate
        };
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/author/evaluationForms/edit/controller.js